import React, {useState,useEffect,useRef,useMemo} from 'react';
import {View, ScrollView, StyleSheet, useWindowDimensions, SafeAreaView,} from 'react-native'
import * as THREE from 'three'
import GLOBE from 'vanta/dist/vanta.globe.min'
import Card from './Card'
import './App.css'


function App() {
    const [bgEffect, setBgEffect] = useState(0),
          dimensions = useWindowDimensions(),
	  layoutRef = useRef(null),
          backgroundStyle = useMemo(() => [
              styles.background,
              {
                  height: dimensions.height * 0.999,
                  width: dimensions.width * 0.999
              }
          ], [dimensions]),
          scrollViewStyle = useMemo(() => [
              styles.scrollView,
              {
                  top: (dimensions.height / 3) - 50,
//                  maxWidth: dimensions.width / 1.4,
                  width: 320
              }
          ], [dimensions])
    
    useEffect(() => {
        if (!bgEffect && layoutRef?.current) {
            setBgEffect(
                GLOBE({
                    el: layoutRef.current,
                    THREE,
		    mouseControls: false,
		    touchControls: false,
		    gyroControls: false,
                    minHeight: 320,
                    minWidth: 320,
		    scale: 0.3,
		    scaleMobile: 0.5,
		    color: 0x2b2a2a,
		    color2: 0xd94d4d,
		    backgroundColor: 0xffffff
		})
            )
        }
	return () => {
            if (bgEffect && bgEffect.destroy)
                bgEffect.destroy()
        }
    }, [bgEffect, layoutRef])

    return <div className="App">
             <SafeAreaView style={styles.safeAreaView}>
               <View style={backgroundStyle} ref={layoutRef} />
               <ScrollView style={scrollViewStyle}>
                 <Card />
               </ScrollView>
             </SafeAreaView>
           </div>
}


const styles = StyleSheet.create({
    safeAreaView: {
	flex: 1,
	flexDirection: 'column',
    },
    background: {
        position: 'sticky',
    },
    scrollView: {
        flexDirection: 'column',
        position: 'absolute',
        left: 20,
        backgroundColor: 'rgba(255,255,255,0.5)',
        padding: 10
    },

})
export default App

